import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'
import { useUpdateUserMutation } from '../../../features/fullApi';
import { toast } from 'react-hot-toast';
import { basicSchema } from "./validation";
import { useForgotPasswordMutation } from '../../../features/authApi';

export default function EditPasswordDialog({openPasswordModal, setOpenPasswordModal, handleUpdateUser}) {
    const user = JSON.parse(localStorage.getItem('user'))
    const [updateUser] = useUpdateUserMutation()

    const [forgotPassword] = useForgotPasswordMutation()

    const onSubmit = async(values, actions) => {
      console.log("CALLED ON SUBMIT", values)
      forgotPassword({email: user?.email, oldPassword: values.oldPassword, newPassword: values.oldPassword})
      .then(res => {
        console.log("res is", res)
        if(!res.error) {
         
        }
        else {
     
        }
      })
      .catch((e) => {
        console.log("wrong credentials", e)
      })
        //   updateUser({_id: user._id, password: values.password }, { 
        //   headers: {
        //       'Token': `Bearer ${user?.accessToken}`
        //   }
        //   }, {id: user._id})
        //   .then(res => {
        //     toast.success('Successfully updated password')
        //     console.log("res is",res)
        //   })
        //   .catch((e) => {
        //   console.log("e is", e)
        //   })
      }
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          newPassword: "",
          newPasswordConfirm: "",
          oldPassword: "",
        },
        validationSchema: basicSchema,
        onSubmit,
      });

    return (
        <form onSubmit={handleSubmit} style={{width: '500px'}}>
            <Dialog fullWidth aria-labelledby='dialog-title' onClose={() => setOpenPasswordModal(false)} open={openPasswordModal}>
                <DialogTitle id='dialog-title'>
                    Change Password
                </DialogTitle>
                <DialogContent>
                    <TextField
                            id="oldPassword"
                            type="text"
                            margin="dense"
                            fullWidth
                            value={values.oldPassword}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label={values.oldPassword ? "" : "Old Password"}
                        />
                        {errors.oldPassword && touched.oldPassword && (
                            <p className="error">{errors.oldPassword}</p>
                    )}
                    <TextField
                        id="newPassword"
                        type="text"
                        margin="dense"
                        fullWidth
                        value={values.newPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.newPassword ? "" : "New Password"}
                    />
                    {errors.newPassword && touched.newPassword && (
                        <p className="error">{errors.newPassword}</p>
                    )}
                    <TextField
                        id="newPasswordConfirm"
                        type="text"
                        margin="dense"
                        fullWidth
                        value={values.newPasswordConfirm}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.newPasswordConfirm ? "" : "Confirm New Password"}
                    />
                    {errors.newPasswordConfirm && touched.newPasswordConfirm && (
                        <p className="error">{errors.newPasswordConfirm}</p>
                    )}
                </DialogContent>
                <DialogActions>
                  <Button
                          color="secondary"
                          onClick={() => 
                            {
                            toast('Canceled ✖');
                            values.newPassword=""
                            values.oldPassword=""
                            values.newPasswordConfirm=""
                            setOpenPasswordModal(false)
                            }
                          }
                          variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleUpdateUser({id: user._id, newPassword: values.newPassword, oldPassword:values.oldPassword})}
                        variant="contained"
                        disabled={(values.newPassword !== values.newPasswordConfirm && errors?.newPassword?.length !== 0 && errors?.newPasswordConfirm?.length !== 0)}
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}